import React from 'react';
import Barcode from 'react-barcode';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import { useAppContext } from '../../../../../Services/AppContext';
import Button from '../../../../../Components/Button/Button';
import Text from '../../../../../Components/Base/Text/Text';

//@ts-ignore
import styles from './ElectronicPrescriptionCreatedDetail.module.scss';

interface Props {
	result: any;
	messageId: string;
	onClose: (needReload: boolean) => void;
	disableMultiplePrescription?: boolean;
}

const ElectronicPrescriptionCreatedDetail: React.FC<Props> = props => {
	const { result, messageId, onClose, disableMultiplePrescription } = props;
	const { socketUrl } = useAppContext();

	return (
		<div className={styles.wrapper}>
			{result && (
				<>
					<Text tx={'nczi.electronicPrescription.detail.successfullyCreated'} />
					<br />
				</>
			)}
			{(result?.messages ?? []).map(
				(message: { code: string; text: string }) => (
					<>
						<Text tx={message.text} className={styles.errorMessage} />
						<br />
					</>
				),
			)}
			{result?.insuranceNote && (
				<>
					<Text tx={result.insuranceNote} className={styles.errorMessage} />
					<br />
				</>
			)}
			{result?.barcode && (
				<div className={styles.barcode}>
					<Barcode value={result.barcode} format={'CODE128'} />
				</div>
			)}
			{!result && !disableMultiplePrescription && (
				<>
					<Text tx={'nczi.result.offline'} className={styles.errorMessage} />
				</>
			)}
			{!result && disableMultiplePrescription && (
				<>
					<Text tx={'nczi.result.manual'} className={styles.errorMessage} />
				</>
			)}
			<br />
			<div className={styles.controls}>
				<Button
					title={'base.shared.close'}
					theme={Theme.GREEN}
					onClick={() => onClose(true)}
					className={styles.button}
				/>
				{!result?.repeat && (
					<>
						<LinkButton
							title={'base.print'}
							theme={Theme.BLUE}
							href={
								(socketUrl.endsWith('/') ? socketUrl.slice(0, -1) : socketUrl) +
								'/nczi-print/message/' +
								messageId
							}
						/>
						<LinkButton
							title={'nczi.action.printWithTemplate'}
							theme={Theme.BLUE}
							href={
								(socketUrl.endsWith('/') ? socketUrl.slice(0, -1) : socketUrl) +
								'/nczi-print/message/' +
								messageId +
								'?extraTemplate'
							}
						/>
					</>
				)}
			</div>
		</div>
	);
};

export default ElectronicPrescriptionCreatedDetail;
